/**
 * Created by fers on 29.07.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import GridList from '../fw/GridList.react';
import Relay from 'react-relay';
import AppPanel from '../fw/AppPanel.react';

import './ChannelDefListForUser.scss';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'appsList.title', 'defaultMessage': 'Apps'},
    search: {id: 'appsList.search', 'defaultMessage': 'Search'},
});

interface ChannelDefListForUserProps {
    intl?: object;
    relay?: object;
    user: User;
}

class ChannelDefListForUser extends React.Component<ChannelDefListForUserProps> {
    static propTypes = {
        intl: PropTypes.object,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }


    onChange = (event) => {
        let lastValue = event.target.value;

        /* wait 250 ms after last change */
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }

        this.delayTimeout = setTimeout(() => {
            this.props.relay.setVariables({
                searchName: lastValue
            });
        }, 250);
    };

    render() {

		let channelDefs = this.props.user.publicChannelDefs;
        let type = types['channelDefs'];

		return (
            <AppPanel className="ChannelDefListForUser" title={this.props.intl.formatMessage(messages.title)}>
                <div className="btn-toolbar" role="toolbar">
                    <div className="input-group">
                        <input className="form-control" name="search" onChange={this.onChange} placeholder={this.props.intl.formatMessage(messages.search)} type="text" />
                        <span className="input-group-addon" id="basic-addon2"><span className="fa fa-search"/></span>
                    </div>
                </div>

                <GridList
					asRow={false}
                    edges={channelDefs}
                    getUrl={(channel) => {
                        return "/apps/" + encodeURIComponent(channel['urlFragment']) + "/";
                    }}
                    iconProperty="icon"
                    metadata={type}
                    relay={this.props.relay}
                    tagsProperty="state"
                    titleProperty="name"
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(injectIntl(ChannelDefListForUser), {
    initialVariables: {
        searchName: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                publicChannelDefs(first: 10000, nameLike: $searchName) {
                    edges {
                        node {
                            id,
                            realId,
                            urlFragment,
                            name,
                            description,
                            state,
                            tags,
                            visibility,
                            aliases,
                            keywords,
                            icon
                        }
                    }
                }
            }
        `,
    },
});
